import Vue, { CreateElement } from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import './pagination.sass'

@Component
export class Pagination extends Vue {

  @Prop({ required: true, default: 0 })
  currentPage: number

  @Prop({ required: true, default: 0 })
  pageSize: number

  @Prop({ required: true, default: 0 })
  total: number

  @Prop({ required: true })
  changePage: (page: number) => void

  @Prop({ required: false })
  resizePage: (size: number) => void

  constructor () {
    super()
  }

  render (h: CreateElement) {
    return <div class='pagination'>
      <el-pagination justify='end'
                     size-change={this.resizePage}
                     onCurrent-change={this.changePage}
                     current-page={this.currentPage}
                     page-size={this.pageSize}
                     layout='prev, pager, next'
                     total={this.total}>
      </el-pagination>
    </div>
  }
}
